var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
// import { propTypes } from 'react-bootstrap/esm/Image'
export var UPDATE_LR_POST_REQUEST = 'UPDATE_LR_POST_REQUEST';
export var UPDATE_LR_POST_SUCCESS = 'UPDATE_LR_POST_SUCCESS';
export var UPDATE_LR_POST_ERROR = 'UPDATE_LR_POST_ERROR';
export var UPDATE_LR_POST_TIMEOUT_START = 'UPDATE_LR_POST_TIMEOUT_START';
export var UPDATE_LR_POST_TIMEOUT_END = 'UPDATE_LR_POST_TIMEOUT_END';
export var LONGREAD_RESET_REQUESTED = 'LONGREAD_RESET_REQUESTED';
export function updateLongReadPost(imageid, post, isVoting) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_LR_POST_REQUEST
        });
        var onSubmit = function (res) {
            var _a;
            dispatch({
                type: UPDATE_LR_POST_SUCCESS,
                payload: res
            });
            var isForm = post.style === 'forms';
            var isSPvote = post.style === 'super-puper-vote';
            var isPodcast = post.style === 'podcast';
            var isImageBlock = ['image', 'big'].includes(post.style);
            var longReadLoadingPost = {};
            if (post.attachments.length === 0) {
                longReadLoadingPost = __assign({ postId: 'updating', userId: post.userId, longreadId: post.longreadId, style: post.style, isFirstLetter: post.isFirstLetter, title: post.title, titlePosition: post === null || post === void 0 ? void 0 : post.titlePosition, text: post.text, localization: null, color: post.color, isHidden: true, isDeleted: true, attachments: [], dateCreate: '2021-05-12T10:01:17.594Z', dateLastChange: '2021-05-12T10:01:17.594Z', like: 0, position: post.position, leagueItem: null, citiesBlock: null, orderList: null, historyList: null, geozoneBlock: null, specBlock: null, votes: post.votes, cardIds: post.cardIds, isRibbon: post.isRibbon }, (isForm ? post === null || post === void 0 ? void 0 : post.additionalInfo : {}));
            }
            else {
                longReadLoadingPost = {
                    postId: isVoting ? post.postId : 'updating',
                    userId: post.userId,
                    longreadId: post.longreadId,
                    style: post.style,
                    isFirstLetter: post.isFirstLetter,
                    title: '',
                    titlePosition: post === null || post === void 0 ? void 0 : post.titlePosition,
                    text: post.text,
                    localization: null,
                    color: post.color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: (isSPvote || isImageBlock || isPodcast) ? (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.map(function (img, idx) { return (__assign({}, img)); }) : [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: post.attachments[0].description,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'updating',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: post.attachments[0] &&
                                    post.attachments[0].file &&
                                    post.attachments[0].file.url,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: post.position,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    votes: post.votes,
                    cardIds: post.cardIds,
                    isRibbon: post.isRibbon
                };
            }
            dispatch({
                type: UPDATE_LR_POST_TIMEOUT_START,
                payload: {
                    data: [longReadLoadingPost],
                    lgId: post.longreadId,
                }
            });
            setTimeout(function () {
                dispatch({
                    type: UPDATE_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: post.longreadId,
                    }
                });
            }, 1000);
        };
        var onError = function () {
            dispatch({
                type: UPDATE_LR_POST_ERROR
            });
        };
        urlApi()
            .updateLongReadPost(imageid, post, onSubmit, onError);
    };
}
//# sourceMappingURL=updateLongReadPost.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
// import { propTypes } from 'react-bootstrap/esm/Image'
export var UPDATE_LR_POST_REQUEST = 'UPDATE_LR_POST_REQUEST';
export var UPDATE_LR_POST_SUCCESS = 'UPDATE_LR_POST_SUCCESS';
export var UPDATE_LR_POST_ERROR = 'UPDATE_LR_POST_ERROR';
export var UPDATE_LR_POST_TIMEOUT_START = 'UPDATE_LR_POST_TIMEOUT_START';
export var UPDATE_LR_POST_TIMEOUT_END = 'UPDATE_LR_POST_TIMEOUT_END';
export var LONGREAD_RESET_REQUESTED = 'LONGREAD_RESET_REQUESTED';
export function updateLongReadPost(imageid, post, isVoting) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_LR_POST_REQUEST
        });
        var onSubmit = function (res) {
            var _a;
            dispatch({
                type: UPDATE_LR_POST_SUCCESS,
                payload: res
            });
            var isForm = post.style === 'forms';
            var isSPvote = post.style === 'super-puper-vote';
            var isPodcast = post.style === 'podcast';
            var isImageBlock = ['image', 'big'].includes(post.style);
            var longReadLoadingPost = {};
            if (post.attachments.length === 0) {
                longReadLoadingPost = __assign({ postId: 'updating', userId: post.userId, longreadId: post.longreadId, style: post.style, isFirstLetter: post.isFirstLetter, title: post.title, titlePosition: post === null || post === void 0 ? void 0 : post.titlePosition, text: post.text, localization: null, color: post.color, isHidden: true, isDeleted: true, attachments: [], dateCreate: '2021-05-12T10:01:17.594Z', dateLastChange: '2021-05-12T10:01:17.594Z', like: 0, position: post.position, leagueItem: null, citiesBlock: null, orderList: null, historyList: null, geozoneBlock: null, specBlock: null, votes: post.votes, cardIds: post.cardIds, isRibbon: post.isRibbon }, (isForm ? post === null || post === void 0 ? void 0 : post.additionalInfo : {}));
            }
            else {
                longReadLoadingPost = {
                    postId: isVoting ? post.postId : 'updating',
                    userId: post.userId,
                    longreadId: post.longreadId,
                    style: post.style,
                    isFirstLetter: post.isFirstLetter,
                    title: '',
                    titlePosition: post === null || post === void 0 ? void 0 : post.titlePosition,
                    text: post.text,
                    localization: null,
                    color: post.color,
                    isHidden: true,
                    isDeleted: true,
                    attachments: (isSPvote || isImageBlock || isPodcast) ? (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.map(function (img, idx) { return (__assign({}, img)); }) : [
                        {
                            postAttachmentId: '',
                            type: 0,
                            referenceId: '',
                            text: 'string',
                            description: post.attachments[0].description,
                            texts: null,
                            descriptions: null,
                            isDeleted: true,
                            file: {
                                fileId: 'updating',
                                containerId: null,
                                isDeleted: false,
                                isNew: false,
                                inProgress: false,
                                type: 'cardimages',
                                url: post.attachments[0] &&
                                    post.attachments[0].file &&
                                    post.attachments[0].file.url,
                                size: null,
                                crop: null,
                                localization: 'global'
                            }
                        }
                    ],
                    dateCreate: null,
                    dateLastChange: null,
                    like: 0,
                    position: post.position,
                    leagueItem: null,
                    citiesBlock: null,
                    orderList: null,
                    historyList: null,
                    geozoneBlock: null,
                    specBlock: null,
                    votes: post.votes,
                    cardIds: post.cardIds,
                    isRibbon: post.isRibbon
                };
            }
            dispatch({
                type: UPDATE_LR_POST_TIMEOUT_START,
                payload: {
                    data: [longReadLoadingPost],
                    lgId: post.longreadId,
                }
            });
            setTimeout(function () {
                dispatch({
                    type: UPDATE_LR_POST_TIMEOUT_END,
                    payload: {
                        data: null,
                        lgId: post.longreadId,
                    }
                });
            }, 1000);
        };
        var onError = function () {
            dispatch({
                type: UPDATE_LR_POST_ERROR
            });
        };
        urlApi()
            .updateLongReadPost(imageid, post, onSubmit, onError);
    };
}
//# sourceMappingURL=updateLongReadPost.js.map